import Select from 'react-select';

const ReactSelect = ({
    autoFocus = false,
    isClearable = false,
    cacheOptions = false,
    placeholder = "Digite para pesquisar...",

    defaultValue = "",
    value = null,

    options = [],

    onChange = () => { },
}) => {

    return (
        <Select
            defaultOptions

            autoFocus={autoFocus}
            cacheOptions={cacheOptions}
            isClearable={isClearable}

            {...(value ? {
                "value": value,
            } : {})}

            defaultValue={defaultValue}

            options={options}

            noOptionsMessage={() => "Sem resultados"}
            loadingMessage={() => "Carregando ..."}
            placeholder={placeholder}

            onChange={onChange}

            styles={{
                control: (styles, state) => (
                    {
                        ...styles,
                        borderRadius: 2,
                        boxShadow: 'none',
                        borderColor: (!state.isFocused) ? '#ccc' : '#6c8fb1',

                        ':hover': {
                            borderColor: '#6c8fb1',
                        },

                        ':active': {
                            borderColor: '#6c8fb1',
                        },
                    }
                )
            }}
        />
    )
}

export default ReactSelect;